import type {
  ActionGroup,
  HandoffActionGroupRequest,
} from '@super/shared-types'

// Reshapes editor action groups into the HTTP request body. Preserves group.id
// when the group was loaded from the server so the API can upsert in place;
// stripping it severs DialOutSettingsActionGroup FKs via cascade on delete.
export function sanitizeActionGroupsForApi(
  actionGroups: ActionGroup[],
): HandoffActionGroupRequest[] {
  return actionGroups.map(group => ({
    ...(group.id && { id: group.id }),
    name: group.name,
    selectionCriteria: group.selectionCriteria,
    selectionType: group.selectionType,
    actions: (group.actions || []).map(action => ({
      actionDefinition: action.actionDefinition
        ? {
            actionType: action.actionDefinition.actionType,
          }
        : undefined,
      parameters: action.parameters,
      integrationId: action.integrationId,
      actionSubtype: action.actionSubtype,
      sourceRoleMemberId: action.sourceRoleMemberId,
    })),
  }))
}
